import "../../new.scss";
import { useState, useEffect } from "react";
import { RamosFormContext } from '../../../context/ramos/RamosContext';
import { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { postRamoData, report, patchRamoData } = useContext(RamosFormContext);
  // ID de edicion 
  const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const nameData = "ramos";  
  const saveData = postRamoData;
  const updateData = patchRamoData;

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm(report);
    }
  }, [report]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

   // Mostrar diálogos
   const openConfirmDialog = () => setIsConfirmDialogOpen(true);
   const closeConfirmDialog = () => setIsConfirmDialogOpen(false);
 
   const openErrorDialog = (message) => {
     setErrorMessage(message);
     setIsErrorDialogOpen(true);
   };
   const closeErrorDialog = () => setIsErrorDialogOpen(false); 

  
  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };
  
    const confirmSendData = async () => {
      setIsSubmitting(true);
      closeConfirmDialog();
  
      try {
        if (id) {
          await updateData(id, form);
        } else {
          await saveData(form);
        }
        navigate(`/${nameData}`);
      } catch (error) {
        console.error(error);
        openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
      } finally {
        setIsSubmitting(false);
      }
    };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs.map((input) => (
                <FormField
                  key={input.id}
                  input={input}
                  value={form[input.name]}
                  handleInputChange={handleChange}
                  error={errors[input.name]}
                />
              ))} </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            {/* Diálogos */}
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
